import { render, staticRenderFns } from "./ExistentDocumentNotificationModal.vue?vue&type=template&id=639735db&scoped=true&"
import script from "./ExistentDocumentNotificationModal.vue?vue&type=script&lang=js&"
export * from "./ExistentDocumentNotificationModal.vue?vue&type=script&lang=js&"
import style0 from "./ExistentDocumentNotificationModal.vue?vue&type=style&index=0&id=639735db&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639735db",
  null
  
)

export default component.exports